export const CONTACT_AVATAR_URL: string = "https://localhost:5002/api/messenger/get-avatar-by-id?avatarId=";
export const OPERATOR_AVATAR_URL: string = "https://localhost:5002/api/operator/get-avatar-by-id?avatarId=";

export const MAX_DISPLAY_CHATS: number = 100;
